import api from "./api";

const paperWalletService = {
    get: (jwttoken) =>
        api.get(`/paper-wallet`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    store: (jwttoken, data) =>
        api.post(`/paper-wallet`, data, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getByCode: (jwttoken, code) =>
        api.get(`/paper-wallet/view/${code}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    updateValidationCode: (jwttoken, code, data) =>
        api.put(`/paper-wallet/updateValidationCode/${code}`, data, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    deposit: (jwttoken, code, data) =>
        api.post(`/paper-wallet/deposit/${code}`, data, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
};

export default paperWalletService;